<template>
  <div class="login">
    <div class="left" :class="isWeixin ? 'weixin' : ''" v-if="value == 0">
      <div class="stitle">Bimmer Meta</div>
      <div class="btitle">welcome back!</div>
      <div class="fList">
        <p @click="value = 2">Tourist Mode</p>
        <p @click="value = 1">Go Register <img src="../assets/newImg/向右3.png" /></p>
      </div>

      <div class="box">
        <input placeholder="Please enter the account number" v-model="account" />
      </div>

      <div class="box">
        <input
          placeholder="Please enter the password"
          v-model="psw"
          show-password
          type="password"
        />
      </div>

      <div class="box box1" @click="login">LOGIN</div>
    </div>

    <div class="left" :class="isWeixin ? 'weixin' : ''" v-if="value == 1">
      <div class="stitle">Bimmer Meta</div>
      <div class="btitle">welcome back!</div>
      <div class="fList">
        <p @click="value = 2">Tourist Mode</p>
        <p @click="value = 0">Go Login <img src="../assets/newImg/向右3.png" /></p>
      </div>

      <div class="box">
        <input placeholder="Please enter the nickname" v-model="nickname" />
      </div>
      <div class="box">
        <input placeholder="Please enter the account number" v-model="raccount" />
      </div>

      <div class="box">
        <input placeholder="Please enter the password" v-model="rpsw" type="password" />
      </div>

      <div class="box">
        <input
          placeholder="Please enter the password agin"
          v-model="cpsw"
          type="password"
        />
      </div>
      <div class="tiaokuan">
        <el-checkbox v-model="checkFlag"></el-checkbox> 我同意相关<span
          class="info"
          @click="tiaokuan"
          >政策和条框</span
        >
      </div>
      <div class="box box1" @click="register">REGISTER</div>
    </div>

    <div class="left" :class="isWeixin ? 'weixin' : ''" v-if="value == 2">
      <div class="stitle">Bimmer Meta</div>
      <div class="btitle">welcome back!</div>
      <div class="fList">
        <p @click="value = 0">Go Login</p>
        <p @click="value = 1">Go Register</p>
      </div>

      <div class="box">
        <input placeholder="Please enter the nickname" v-model="nickname1" />
      </div>

      <div class="box box1" @click="login1">LOGIN</div>
    </div>
    <img src="../assets/mobile/bg.png" class="pic" />
    <img src="../assets/mobile/yuan.png" class="yuan" />
    <img class="logo" src="../assets/newImg/logo.png" />
  </div>
</template>

<script>
import { register, login, mail_send, mail_verify, save } from "../assets/api/index";
import axios from "axios";
import md5 from "js-md5";
export default {
  data() {
    return {
      type: "",
      account: "",
      psw: "",
      nickname: "",
      nickname1: "",
      raccount: "",
      rpsw: "",
      cpsw: "",
      value: 0,
      // options: [
      //   {
      //     value: "zh",
      //     label: this.$t("info.lang.zh"),
      //   },
      //   {
      //     value: "en",
      //     label: this.$t("info.lang.en"),
      //   },
      // ],
      // lang: "zh",
      activeName: "login",
      vnum: "",

      isWeixin: true,
    };
  },
  methods: {
    tiaokuan() {
      this.$alert(
        "在您开始使用我们的产品和服务前，请您务必先仔细阅读和理解本政策，确保您充分理解和同意之后再开始使用。本政策中涉及的专业词汇，我们尽量以简明通俗的表述向您解释，以便于您理解。您同意隐私政策表示您已了解应用提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集使用授权，但并不代表您已单独同意开启附加功能、处理非必要个人信息，相关附加功能的开启、处理非必要个人信息以及处理敏感个人信息，我们会根据您的实际使用情况单独征求您的同意。在您使用我们的产品与/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：1、为实现向您提供我们产品与/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品与/或服务；2、为实现向您提供我们产品与/或服务的附加功能，您可选择单独同意或不同意我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，不会影响您使用我们的基本功能。我们在此特别提醒您：我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品与/或服务范围存在差异，故基本/附加功能及对应收集使用的个人信息类型、范围会有所区别，请以具体的产品与/或者服务功能为准。",
        "隐私保护政策",
        {
          confirmButtonText: "我已阅读",
          callback: (action) => {},
        }
      );
    },
    reloadcode() {
      if (!this.email1 || !this.email2) {
        this.$message.error("请填写完整邮箱");
        return;
      }
      var email = `${this.email1}${this.email2}`;
      mail_send({ email }).then((res) => {
        this.$message(res);
        this.timmer = setInterval(() => {
          this.time--;
          this.msg = `还剩${this.time}s`;

          if (this.time == 0) {
            this.time = 30;
            clearInterval(this.timmer);
            this.msg = "获取邮箱验证码";
          }
        }, 1000);
      });
    },
    login() {
      console.log(axios.defaults.baseURL);
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.account || !this.psw) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else if (!reg.test(this.account)) {
        this.$message.error(this.$t("info.lang.loginError5"));
      } else {
        login({
          acount: this.account,
          psd: md5(this.psw),
        }).then((res) => {
          if (res.code != 1) {
            this.$message({
              message: this.$t("info.lang.loginSuccess"),
              type: "success",
            });
            var obj = {
              acount: this.account,
              psd: md5(this.psw),
            };
            localStorage.setItem("info", JSON.stringify(obj));

            this.$router.push({ name: "mobileIndex" });
            document.o2.firstLogin = true;
          } else {
            this.$message.error(res.error);
          }
        });
      }
    },

    register() {
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      var reg1 = /^[\u4E00-\u9FA5A-Za-z0-9_]+$/;

      console.log(this.raccount, this.rpsw);
      if (!this.raccount || !this.rpsw || !this.nickname || !this.cpsw) {
        this.$message.error(this.$t("info.lang.loginError1"));
      } else if (!reg.test(this.raccount)) {
        this.$message.error(this.$t("info.lang.loginError5"));
        // } else if (this.psw != "123456") {
        //   this.$message.error(this.$t("info.lang.loginError2"));
      } else if (this.cpsw != this.rpsw) {
        this.$message.error(this.$t("info.lang.passwordInfo2"));
      } else if (!reg1.test(this.nickname)) {
        this.$message.error("昵称不能包含特殊符号");
      } else {
        if (this.type == 1) {
          mail_verify({
            code: this.emailcode,
            email: `${this.email1}${this.email2}`,
          }).then((res) => {
            console.log(res);

            if (res == false) {
              this.$message.error("邮箱验证失败");
            } else {
              register({
                name: this.nickname,
                acount: this.raccount,
                psd: md5(this.rpsw),
              }).then((res) => {
                if (res.code == 0) {
                  save({
                    name: this.nickname,
                    info: JSON.stringify({
                      email: `${this.email1}${this.email2}`,
                      type: this.type,
                      name: this.nickname,
                      sex: 1,
                      accInfo: "0-0-0-1",
                      avatar: 0,
                      bodyColor: "#F66C47",
                      hairColor: "#191919",
                    }),
                    auth: 2,
                  }).then((res) => {
                    if (res.code == 0) {
                      this.account = this.raccount;
                      this.value = 0;
                    }
                  });
                  this.$message({
                    message: res.info,
                    type: "success",
                  });
                } else {
                  this.$message.error(res.info);
                }
              });
            }
          });
        } else {
          register({
            name: this.nickname,
            acount: this.raccount,
            psd: md5(this.rpsw),
          }).then((res) => {
            if (res.code == 0) {
              save({
                name: this.nickname,
                info: JSON.stringify({
                  email: this.email,
                  type: this.type,
                  name: this.nickname,
                  sex: 1,
                  accInfo: "0-0-0-1",
                  avatar: 0,
                  bodyColor: "#F66C47",
                  hairColor: "#191919",
                }),
                auth: 2,
              }).then((res) => {
                if (res.code == 0) {
                  this.account = this.raccount;
                  this.activeName = "login";
                }
              });

              this.$message({
                message: res.info,
                type: "success",
              });
            } else {
              this.$message.error(res.info);
            }
          });
        }
      }
    },

    login1() {
      var obj = {
        acount: this.num,
        psd: 123,
        type: true,
        name: this.nickname1,
      };

      localStorage.setItem("info", JSON.stringify(obj));
      this.$router.push({ name: "mobileIndex" });
      document.o2.firstLogin = true;
    },

    getRandomSixNum() {
      let RandomSixStr = "";
      for (let i = 0; i < 6; i++) {
        RandomSixStr += String(Math.floor(Math.random() * 10));
      }
      return RandomSixStr;
    },
  },
  watch: {
    lang(val) {
      this.$i18n.locale = val;
      this.options[0].label = this.$t("info.lang.zh");
      this.options[1].label = this.$t("info.lang.en");
      localStorage.setItem("locale", val);
    },

    value(val) {
      if (val == 2) {
        this.vnum = this.getRandomSixNum();
        this.nickname1 = `游客${this.vnum}`;
      }
    },
  },

  beforeCreate() {
    console.log("加载开始");
    if (localStorage.getItem("info")) {
      this.$router.push({ name: "mobileIndex" });
    }
  },

  created() {
    if (localStorage.getItem("locale")) {
      console.log(localStorage.getItem("locale"));
      this.lang = localStorage.getItem("locale");
    }

    function is_weixin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    }
    this.isWeixin = is_weixin();
  },
};
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  color: #333333;
  font-family: BMW Group, BMW Group-Bold;

  .left {
    width: 374px;
    transform: skew(30deg) scale(0.4);
    height: 400px;
    margin-left: -38px !important;
    margin-top: -90px !important;
  }
  .weixin {
    margin-left: -25px !important;
    margin-top: -80px !important;
  }
  .stitle {
    font-size: 16px;
    font-weight: 700;
    text-align: left;

    margin-top: 30px;
    transform: skew(-30deg);
  }
  .btitle {
    font-size: 39px;
    font-weight: 700;
    text-align: left;
    transform: skew(-30deg);
  }
  .fList {
    display: flex;
    width: 374px;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    color: #999;
    margin-top: 13px;
    transform: skew(-30deg);

    p {
      display: flex;
      align-items: center;
      img {
        margin-left: 5px;
      }
    }
    cursor: pointer;
  }
}
.pic {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.logo {
  position: fixed;
  top: 150px;

  width: 200px;
  right: 50px;
  margin: auto;
}

.yuan {
  height: 100%;
  position: fixed;
  right: 36px;
  top: 0;
}

.box {
  width: 374px;
  height: 52px;
  background: url("../assets/newImg/box.png");
  transform: skew(-30deg);
  margin-top: 20px;

  input {
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400;
    text-align: left;
    color: #333333;
    height: 100%;
    border: 0;
    width: 80%;
    outline: none;
  }
}

.box2 {
  width: 374px;
  height: 52px;
  transform: skew(-30deg);
}

.box1 {
  background: url("../assets/newImg/box1.png");
  font-size: 18px;
  font-family: Microsoft YaHei, Microsoft YaHei-Bold;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.tiaokuan {
  text-align: left;
  margin: 20px 0 0 20px;
  transform: skew(-30deg);
}

@media screen and (max-width: 500px) {
  .login {
    .info {
      width: 100%;
    }
    .pic {
      width: 0;
    }
  }
}
</style>
